import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useInfiniteGetSymptomReports } from 'services/symptom-checker/hooks';
import useAuthStore from 'store/auth';
import ReportDetail from '../ReportDetail';
import { SymptomCheckerReport } from 'services/symptom-checker/type';
import { PATH_ROUTES } from 'routes/path';
import PreviousReports from './PreviousReports';
import { LoadMoreButton } from 'components/LoadMoreButton';
import Loader from 'components/Loader';
import GenerateReport from './GenerateReport';
import MobileReport from '../MobileReport';

export default function SymptomCheckerPage() {
  const navigate = useNavigate();
  const profileId = useAuthStore((store) => store.currentUserProfileId);

  const {
    data: symptomReports,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
    hasNextPage,
  } = useInfiniteGetSymptomReports(profileId, 1);

  const [selectedTokenId, setSelectedTokenId] = useState<string>('');
  const [reportData, setReportData] = useState<SymptomCheckerReport[]>([]);

  useEffect(() => {
    if (symptomReports?.length) {
      setReportData(symptomReports);
      setSelectedTokenId(symptomReports[0].token_id);
    } else {
      setReportData([]);
      setSelectedTokenId('');
    }

    if (symptomReports && !symptomReports.length) {
      navigate(PATH_ROUTES.GENERATE_SYMPTOM_CHECKER);
    }
  }, [symptomReports]);

  const scrollViewElement = (
    <div>
      {hasNextPage && !isFetchingNextPage ? (
        <LoadMoreButton
          onClick={() => fetchNextPage()}
          className='border-t-0'
        />
      ) : isFetchingNextPage ? (
        <Loader className='h-12' loaderSize='size-6' />
      ) : null}
    </div>
  );

  if (isLoading) return <Loader />;

  return (
    <div>
      <MobileReport
        reportData={reportData}
        setReportData={setReportData}
        scrollViewElement={scrollViewElement}
        isLoading={isLoading}
      />

      <div className='hidden px-6 pt-4 lg:block'>
        <div className='grid grid-cols-6 lg:grid-cols-10 xl:grid-cols-9 gap-x-8'>
          <div className='col-span-2 space-y-4 lg:col-span-3 xl:col-span-2'>
            <GenerateReport />

            <PreviousReports
              reportData={reportData}
              tokenId={selectedTokenId}
              setTokenId={setSelectedTokenId}
              setReportData={setReportData}
              scrollViewElement={scrollViewElement}
              isLoading={isLoading}
              reportType='symptom'
            />
          </div>

          <div className='col-span-1 sm:col-span-8 lg:col-span-7 xl:col-span-7'>
            <ReportDetail tokenId={selectedTokenId} />
          </div>
        </div>
      </div>
    </div>
  );
}
